<template>
  <v-app>
    <v-content>
      <router-view
        :apiUrl="apiUrl"
        :serverData="serverData"
      ></router-view>
    </v-content>
  </v-app>
</template>

<script>
import serverData from '@/server/data.json'
import axios from 'axios'

export default {
  data () {
    return {
      apiUrl: '//localhost:8000/api',
      serverData: serverData
    }
  },
  props: {
    toolbar: {
      default: false
    }
  }
}

// Axios Config Interceptors
axios.interceptors.request.use(function (config) {
  if (localStorage.getItem('token') != null) {
    let access = localStorage.getItem('token')
    config.headers['Authorization'] = 'Bearer ' + access
  }

  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})
</script>


// WEBPACK FOOTER //
// src/Merck.vue